import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageKMZComponent } from './manage-KMZ/manage-KMZ.component';
import { LoginDetailsComponent } from './login-details/login-details.component';
import { AddLoginFormComponent } from './add-login/add-login.component';
import { ManageServiceProviderEditComponent } from './manage-service-provider-edit/manage-service-provider-edit.component';
import { ManageServiceProviderComponent } from './manage-service-provider/manage-service-provider.component';
import { SearchhistoryComponent } from './searchhistory/searchhistory.component';
import { ManageResellerComponent } from './manage-reseller/manage-reseller.component';
import { ManageResellerAddComponent } from './manage-reseller-add/manage-reseller-add.component';
import { UploadFSANNumberComponent } from './upload-FSAN-Number/upload-FSAN-Number.component';
import { ManageResellerProductComponent } from './manage-reseller-product/manage-reseller-product.component';
import { ManageProductComponent } from './manage-product/manage-product.component';
import { ManageProductAddComponent } from './manage-product-add/manage-product-add.component';
import { ShopPromotionsComponent } from './shop-promotions/shop-promotions.component';
import { ManageSubCategComponent } from './manage-sub-Categ/manage-sub-Categ.component';
import { AddManageSubCategComponent } from './manage-sub-Categ-add/manage-sub-Categ-add.component';
import { ManageSalesRepComponent } from './manage-sales-rep/manage-sales-rep.component';
import { AddManageSalesRepComponent } from './manage-sales-rep-add/manage-sales-rep-add.component';
import { SalesTargetSetupComponent } from './sales-target-setup/sales-target-setup.component';
import { AddSalesTargetSetupComponent } from './sales-target-setup-add/sales-target-setup-add.component';
import { ShopPromotionsAddComponent } from './shop-promotions-add/shop-promotions-add.component';
import { VumatelProductMappingComponent } from './vumatel-product-mapping/vumatel-product-mapping.component';
import { ShoppingConfigurationComponent } from './shopping-configuration/shopping-configuration.component';
import { CustomerPriceUpdateComponent } from './customer-price-update/customer-price-update.component';
import { SchoolPackageComponent } from './school-package/school-package.component';
import { CustomerAmmendmentComponent } from './customer-ammendment/customer-ammendment.component';
import { ManageDeviceComponent } from './manage-device/manage-device.component';
import { CourierWaybilComponent } from './courier-waybil/courier-waybil.component';
import { ManageServiceChangeRequestComponent } from './manage-service-change-request/manage-service-change-request.component';
import { UpgradeApprovalComponent } from './upgrade-approval/upgrade-approval.component';
import { ManageCancellationComponent } from './manage-cancellation/manage-cancellation.component';
import { ManageActivityComponent } from './manage-activity/manage-activity.component';
import { AddActivityComponent } from './add-activity/add-activity.component';
import { ManageActionComponent } from './manage-action/manage-action.component';
import { ManageActionDetailsComponent } from './manage-action-details/manage-action-details.component';
import { NewUserComponent } from './new-user/new-user.component';
import { RainItemizedBillingComponent } from './rain-itemized-billing/rain-itemized-billing.component';
import { LinkAddressChangeComponent } from './link-address-change/link-address-change.component';
import { TraceRemovalOperationComponent } from './trace-removal-operation/trace-removal-operation.component';
import { ManageSuspensionComponent } from './manage-suspension/manage-suspension.component';
import { ManageAdhocComponent } from './manage-adhoc/manage-adhoc.component';
import { LoginTrendAnalysisComponent } from './login-trend-analysis/login-trend-analysis.component';
import { ViewAllFnoPackagesComponent } from './view-all-fno-packages/view-all-fno-packages.component';
import { MessagingComponent } from './messaging/messaging.component';
import { MessagingAddComponent } from './messaging-add/messaging-add.component';
import { PortalNotificationsComponent } from './portal-notifications/portal-notifications.component';
import { CollectionComponent } from './collection/collection.component';
import { ProductAndPriceChangeComponent } from './product-and-price-change/product-and-price-change.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { PaymentArrangementComponent } from './payment-arrangement/payment-arrangement.component';
import { ChangeOfBankDetailsComponent } from './change-of-bank-details/change-of-bank-details.component';
import { AmendBankingDetailsComponent } from './amend-banking-details/amend-banking-details.component';
import { BulkSuspensionReactivationComponent } from './bulk-suspension-reactivation/bulk-suspension-reactivation.component';
import { AddBulkSuspensionComponent } from './add-bulk-suspension/add-bulk-suspension.component';
import { ManagePushNotificationComponent } from './manage-push-notification/manage-push-notification.component';
import { ManagePushNotificationAddComponent } from './manage-push-notification-add/manage-push-notification-add.component';
import { VumatelNetworkEventsComponent } from './vumatel-network-events/vumatel-network-events.component';
import { ViewVumatelNetworkEventsComponent } from './view-vumatel-network-events/view-vumatel-network-events.component';
import { ManagePromotionAddComponent } from './manage-promotion-add/manage-promotion-add.component';
import { ManagePromotionComponent } from './manage-promotion/manage-promotion.component';
import { PromotionSimulationComponent } from './promotion-simulation/promotion-simulation.component';
import { NetworkOutageComponent } from './network-outage/network-outage.component';
import { NetworkOutageAddComponent } from './network-outage-add/network-outage-add.component';
import { RemovePromotionComponent } from './remove-promotion/remove-promotion.component';
import { LteManageInventoryComponent } from './lte-manage-inventory/lte-manage-inventory.component';
import { LtetopuphistoryComponent } from './ltetopuphistory/ltetopuphistory.component';
import { ManageOtpNotificationComponent } from './manage-otp-notification/manage-otp-notification.component';
import { ManageReferralFriendsComponent } from './manage-referral-friends/manage-referral-friends.component';
import { RelocationReferralPopupComponent } from './relocation-promotion/relocation-referral-popup/relocation-referral-popup.component';
import { ManageRelocationPromotionComponent } from './relocation-promotion/manage-relocation-promotion/manage-relocation-promotion.component';
import { RelocationPromotionComponent } from './relocation-promotion/relocation-promotion/relocation-promotion.component';
import { NetworkStatusComponent } from './network-status/network-status.component';
import { ManagePaymentArrangementComponent } from './manage-payment-arrangement/manage-payment-arrangement.component';
import { SuspensionScheduleComponent } from './suspension-schedule/suspension-schedule.component';
import { SuspensionProcessHistoryComponent } from './suspension-process-history/suspension-process-history.component';
import { AccountTransferExistingComponent } from './account-transfer-existing/account-transfer-existing.component';
import { ManageResellerSalesComponent } from './manage-reseller-sales/manage-reseller-sales.component';
import { ManageResellerSalesAddComponent } from './manage-reseller-sales-add/manage-reseller-sales-add.component';
import { RadactComponent } from './radact/radact.component';

const routes: Routes = [
  {
    path: 'kmz',
    component: ManageKMZComponent,
  },
  {
    path: 'homeConnectUser',
    component: LoginDetailsComponent,
  },
  {
    path: 'homeConnectUser/:id',
    component: AddLoginFormComponent,
  },
  {
    path: 'serviceprovider',
    component: ManageServiceProviderComponent,
  },
  {
    path: 'serviceprovider/:id/:type',
    component: ManageServiceProviderEditComponent,
  },
  {
    path: 'searchhistory',
    component: SearchhistoryComponent,
  },
  {
    path: 'reseller',
    component: ManageResellerComponent,
  },
  {
    path: 'reseller/:id',
    component: ManageResellerAddComponent,
  },
  {
    path: 'uploadFSANNumber',
    component: UploadFSANNumberComponent,
  },
  {
    path: 'manageResellerProduct',
    component: ManageResellerProductComponent,
  },
  {
    path: 'product',
    component: ManageProductComponent,
  },
  {
    path: 'product/:id',
    component: ManageProductAddComponent,
  },
  {
    path: 'manageshoppromotions',
    component: ShopPromotionsComponent,
  },
  {
    path: 'addBanner/:id',
    component: ShopPromotionsAddComponent,
  },
  {
    path: 'subcategory',
    component: ManageSubCategComponent,
  },
  {
    path: 'subcategory/:id',
    component: AddManageSubCategComponent,
  },
  {
    path: 'salesrep',
    component: ManageSalesRepComponent,
  },
  {
    path: 'salesrep/:id',
    component: AddManageSalesRepComponent,
  },
  {
    path: 'salestarget',
    component: SalesTargetSetupComponent,
  },
  {
    path: 'salestarget/:id/:type',
    component: AddSalesTargetSetupComponent,
  },
  {
    path: 'vumatelProductMapping',
    component: VumatelProductMappingComponent,
  },
  {
    path: 'shoppingConfiguration',
    component: ShoppingConfigurationComponent,
  },
  {
    path: 'recurringProduct',
    component: CustomerPriceUpdateComponent,
  },
  {
    path: 'schoolPackage',
    component: SchoolPackageComponent,
  },
  {
    path: 'amendCustomer',
    component: CustomerAmmendmentComponent,
  },
  {
    path: 'devices',
    component: ManageDeviceComponent,
  },
  {
    path: 'courierWaybill',
    component: CourierWaybilComponent,
  },
  {
    path: 'manageServiceChangeRequest/:id',
    component: ManageServiceChangeRequestComponent,
  },
  {
    path: 'upgradeapproval/:id',
    component: UpgradeApprovalComponent,
  },
  {
    path: 'manageCancellation/:id',
    component: ManageCancellationComponent,
  },
  {
    path: 'activity',
    component: ManageActivityComponent,
  },
  {
    path: 'addactivity/:id',
    component: AddActivityComponent,
  },
  {
    path: 'manageaction',
    component: ManageActionComponent,
  },
  {
    path: 'manageactiondetails/:id',
    component: ManageActionDetailsComponent,
  },
  {
    path: 'newuser',
    component: NewUserComponent,
  },
  {
    path: 'rainItemizedBilling',
    component: RainItemizedBillingComponent,
  },
  {
    path: 'linkAddressChange',
    component: LinkAddressChangeComponent,
  },
  {
    path: 'traceRemovalOperation',
    component: TraceRemovalOperationComponent,
  },
  {
    path: 'suspensionDashboard',
    component: ManageSuspensionComponent,
  },
  {
    path: 'createSuspensionSchedule',
    component: SuspensionScheduleComponent,
  },
  {
    path: 'managePaymentArrangement',
    component: ManagePaymentArrangementComponent,
  },

  {
    path: 'adhoc',
    component: ManageAdhocComponent,
  },

  {
    path: 'loginTrendAnalysis',
    component: LoginTrendAnalysisComponent,
  },
  {
    path: 'showAllFnoPackages',
    component: ViewAllFnoPackagesComponent,
  },
  {
    path: 'messaging',
    component: MessagingComponent,
  },
  {
    path: 'messaging-add',
    component: MessagingAddComponent,
  },
  {
    path: 'debitordernotification',
    component: PortalNotificationsComponent,
  },
  {
    path: 'collection',
    component: CollectionComponent,
  },
  {
    path: 'productandpricechange',
    component: ProductAndPriceChangeComponent,
  },
  {
    path: 'paymentHistory',
    component: PaymentHistoryComponent,
  },
  {
    path: 'paymentArrangement',
    component: PaymentArrangementComponent,
  },
  {
    path: 'viewbankingdetails',
    component: ChangeOfBankDetailsComponent,
  },
  {
    path: 'addbankingdetails',
    component: AmendBankingDetailsComponent,
  },
  {
    path: 'addbankingdetails/:applicationId',
    component: AmendBankingDetailsComponent,
  },
  {
    path: 'managebulksuspendrevoke',
    component: BulkSuspensionReactivationComponent,
  },
  {
    path: 'bulksuspendrevoke',
    component: AddBulkSuspensionComponent,
  },
  {
    path: 'managePushNotification',
    component: ManagePushNotificationComponent,
  },
  {
    path: 'pushNotification',
    component: ManagePushNotificationAddComponent,
  },
  {
    path: 'vumatelNetworkEvents',
    component: VumatelNetworkEventsComponent,
  },
  {
    path: 'viewvumatelNetworkEvents/:id',
    component: ViewVumatelNetworkEventsComponent,
  },
  {
    path: 'managepromotionadd/:id/:type',
    component: ManagePromotionAddComponent,
  },
  {
    path: 'managepromotion',
    component: ManagePromotionComponent,
  },
  {
    path: 'promotionsimulation/:id/:type',
    component: PromotionSimulationComponent,
  },
  {
    path: 'networkoutage',
    component: NetworkOutageComponent,
  },
  {
    path: 'addnetworkoutage/:id',
    component: NetworkOutageAddComponent,
  },
  {
    path: 'removepromotion',
    component: RemovePromotionComponent,
  },
  {
    path: 'lte-manage-inventory',
    component: LteManageInventoryComponent,
  },
  {
    path: 'ltetopuphistory',
    component: LtetopuphistoryComponent,
  },
  {
    path: 'manageotpnotification',
    component: ManageOtpNotificationComponent,
  },

  {
    path: 'managereferralfriends',
    component: ManageReferralFriendsComponent,
  },
  {
    path: 'manage-relocation-promotion',
    component: ManageRelocationPromotionComponent,
  },
  {
    path: 'relocation-promotion',
    component: RelocationPromotionComponent,
  },
  {
    path: 'relocation-referral-popup',
    component: RelocationReferralPopupComponent,
  },
  {
    path: 'networkstatus',
    component: NetworkStatusComponent,
  },
  {
    path: 'account-transfer-existing',
    component: AccountTransferExistingComponent
  },
  {
    path: 'reseller-sales',
    component: ManageResellerSalesComponent,
  },
  {
    path: 'reseller-sales/:id/:mode',
    component: ManageResellerSalesAddComponent,
  },
  {
    path: 'session-log',
    component: RadactComponent,
  },
  {
    path: 'payment-transactions',
    redirectTo: 'paymentHistory',
    pathMatch: 'full',
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdditionalFeaturesRoutingModule { }
